export default "__VITE_ASSET__CoSPEBjH__"